import { sortBy, prop } from 'ramda';

export const getStationOptions = (stations, searchString) => {
  if (searchString.length < 3) {
    return [];
  }

  const filteredStations = stations.filter((station) =>
    station.searchStrings.find((s) => s.replace(/[^\w\s]/gi, '').startsWith(searchString.toLowerCase()))
  );

  return sortBy(prop('priority'), filteredStations);
};
